import { SuccessCircle } from "components/assets/Icons";
import styles from "./Message.module.scss";

const Message = ({ text }) => {
  return (
    <div className={styles.container}>
      <SuccessCircle />
      <p className={styles.text}>{text}</p>
    </div>
  );
};

export default Message;
